import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';

import config from './config.js'
import {RE} from '@/config.js'
import library from '@deanwu/vue-component-library'
import '@deanwu/vue-component-library/dist/vue-component-library.css'
Vue.use(library, config);

import comps from './components/index.js'
Vue.use(comps);
import dialog from './components/dialog.js'
Vue.use(dialog);
import print from '@/components/public/print.js'
Vue.use(print);

import 'jodit/build/jodit.min.css'
import JoditVue from 'jodit-vue'
Vue.use(JoditVue)

Vue.prototype.RE = RE;

Vue.prototype.$bus = new Vue();

Vue.prototype.lock = function(val) {
	return val && this.$store.getters.freeEdition && !this.$store.getters.freeAuthKey.includes(val);
}

// 获取APP.vue实例
Vue.prototype.getApp = function() {
	return app.$children[0];
};

// 获取pages/index.vue实例
Vue.prototype.getSys = function() {
	return app.$children[0].$children.find(item => item.$options.name == 'Sys');
};

Vue.prototype.uploadConfig = function(opt) {
	window._uploadConfig = opt;
}

Vue.prototype.oss = function(url, w, h) {
	if (!url) return '';
	return `${url}?x-oss-process=image/resize,h_${h * 2},w_${w * 2}/quality,q_80`;
};

Vue.prototype.dialogFormEditConfirm = function($form, events) {
	if ($form && $form.editState) {
		events[0]();
		this.$confirm({
			message: '关闭后已更改的数据将会丢失，确定要关闭吗？',
			cancelButtonName: '继续编辑',
			resolve: () => {
				$form.setEditState && $form.setEditState(false);
				events[1]();
			}
		})
	}
};

Vue.prototype.freeEditionTips = function(route) {
	this.$confirm({
		zIndex: 9999,
		type: 'warn',
		title: '功能暂不可用',
		message: '此功能为<b style="color: #9F5A16;">【专业版】</b>功能，请开通专业版后使用',
		buttonName: '开通专业版',
		resolve: () => {
			this.navigateTo('/upgrade');
		},
		cancel: () => {
			route && this.navigateTo('/');
		}
	})
};

Vue.prototype.checkDataCount = function(code, id) {
	return this.request({
		url: '/system/verifiedCount',
		data: {
			work_code: code,
			work_type_id: id
		},
		loading: true,
		success: (data, msg) => {
			if (!data) {
				let type = this.$store.getters.freeEdition ? 'free' : 'vip';
				// let limit = code == 'SYSTEM_USER' ? this.$store.state.saasInfo.max_account_count : this.$store.state.systemConfig[{
				// 	SYSTEM_VIEW: `${type}_view_count`,
				// 	PRODUCT: `${type}_product_count`,
				// 	PROCESS: `${type}_process_count`,
				// 	WAREHOUSE: `${type}_warehouse_count`,
				// 	SALARY_MATCH_CONFIG: `${type}_salary_match_count`,
				// 	SYSTEM_FIELD: `${type}_field_count`
				// }[code]];
				
				if (this.$store.getters.freeEdition) {
					this.$confirm({
						type: 'warn',
						title: '数据条数已达上限',
						message: msg,
						buttonName: '开通专业版',
						resolve: () => {
							this.navigateTo('/upgrade');
						}
					});
				} else {
					this.$confirm({
						type: 'warn',
						title: '数据条数已达上限',
						message: msg,
						buttonName: '我知道了',
						cancelButton: false
					});
				}
			}
		}
	});
};

const buttonLockHandle = function(el, lock) {
	let vm = el.__vue__;
	let vip = el.childNodes[0].querySelector('.vip');
	if (lock) {
		if (!el._lockInterceptor) {
			el._lockInterceptor = (e) => {
				e.stopImmediatePropagation();
				e.preventDefault();
				vm.freeEditionTips();
			};
			el.addEventListener('click', el._lockInterceptor, true);
		}

		// if (!vip) {
		// 	vip = new Image();
		// 	vip.src = require('@/assets/image/vip.png');
		// 	vip.className = 'vip';
		// 	vip.style.height = '14px';
		// 	vip.style.marginLeft = '4px';
		// 	vip.style.marginBottom = '1px';
		// 	el.childNodes[0].appendChild(vip);
		// }
	} else {
		vip && el.childNodes[0].removeChild(vip);
		el.removeEventListener('click', el._lockInterceptor, true);
		delete el._lockInterceptor;
	}
}

Vue.directive('lock', {
	inserted(el, {value: lock}) {
		let vm = el.__vue__;
		if (lock && vm && vm.$options.name == 'cTableButton') {
			vm.$off('click');
			vm.$on('click', () => {
				vm.freeEditionTips();
			});

			setTimeout(() => {
				let group = el.parentNode.parentNode;
				let more = group.__vue__ ? group.__vue__.$refs.list : null;
				let node = group.querySelector(`[title='${el.innerText}']`) || (more ? more.querySelector(`[title='${el.innerText}']`) : null);
				// if (node) {
				// 	let vip = new Image();
				// 	vip.src = require('@/assets/image/vip.png');
				// 	vip.style.height = '14px';
				// 	vip.style.marginLeft = '2px';
				// 	vip.style.marginBottom = '2px';
				// 	node.appendChild(vip);
				// }
			}, 100);
		} else if (vm && vm.$options.name == 'cButton') {
			buttonLockHandle(el, lock);
		}
	},

	update(el, {value: lock}) {
		let vm = el.__vue__;
		if (vm && vm.$options.name == 'cButton') {
			buttonLockHandle(el, lock);
		}
	}
});

Vue.prototype.window = window;

Vue.config.productionTip = false;

const app = window.$app = new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
